import { createAction } from 'redux-actions';

import { globalTypes } from './types';

const _createAction = (storeName, type, payload) => ({
    type: `${storeName}.${type}`,
    payload,
});

const init = createAction(globalTypes.INITIALIZE);

const changeDataFieldValue = (storeName, actionName, value) =>
    _createAction(storeName, actionName, value);

export default {
    init,
    changeDataFieldValue,
};
